export const UPDATE_CART_DATA = 'UPDATE_CART_DATA';
export const SET_POPUP = 'SET_POPUP';
export const SET_PROMOTIONS = 'SET_PROMOTIONS';
export const SET_SHIPPING_TAX = 'SET_SHIPPING_TAX'
export const SET_PROMOTIONS_FREE_DESCRIPTION = 'SET_PROMOTIONS_FREE_DESCRIPTION';
export const SET_DISCOUNT_PRICE = 'SET_DISCOUNT_PRICE';
export const CART_REMOVE_ITEM_PENDING = 'CART_REMOVE_ITEM_PENDING';
export const CART_REMOVE_ITEM_FULFILLED = 'CART_REMOVE_ITEM_FULFILLED';
